import React, { useEffect, useState } from "react";
import accountsApi from "../../services/accountsCommonService";
import { formatINR } from "../../Pages/accounts/accountUser";

function CreditRow({ label, value, bold, negative }) {
  return (
    <div className="accounts-credit-row">
      <span>{label}</span>
      <strong className={`${negative ? "accounts-money-neg" : ""} ${bold ? "is-bold" : ""}`}>{value}</strong>
    </div>
  );
}

export default function CreditPanel({ customerId, orderAmount }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!customerId) {
      setData(null);
      return undefined;
    }
    let live = true;
    setLoading(true);
    accountsApi.customerCredit(customerId)
      .then((result) => { if (live) setData(result.data); })
      .catch((err) => { if (live) setError(err.message); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [customerId]);

  if (!customerId) return <p className="accounts-hint">Select a customer to see their credit position.</p>;
  if (!data) return <p className="accounts-hint">{error || "Loading credit position…"}</p>;
  const checking = orderAmount !== undefined && orderAmount !== null;
  const used = Number(data.outstanding) + Number(data.openOrders) + (checking ? Number(orderAmount) || 0 : 0);
  const after = Number(data.creditLimit) - used;
  const percent = data.creditLimit > 0 ? Math.min(100, Math.max(0, (used / data.creditLimit) * 100)) : 100;
  const over = after < 0;
  const bar = over ? "is-over" : percent > 80 ? "is-warn" : "is-ok";
  return (
    <div className={loading ? "accounts-dim" : ""}>
      <CreditRow label="Credit limit" value={formatINR(data.creditLimit)} bold />
      <CreditRow label="Outstanding (owed now)" value={formatINR(data.outstanding)} />
      <CreditRow label="of which already due" value={formatINR(data.amountDue)} negative={data.amountDue > 0} />
      <CreditRow label="Open orders not yet invoiced" value={formatINR(data.openOrders)} />
      {checking && <CreditRow label="This order" value={formatINR(orderAmount)} />}
      <div className="accounts-progress"><span className={bar} style={{ width: `${percent}%` }} /></div>
      <CreditRow label={checking ? "Credit left after this order" : "Available credit"} value={formatINR(after)} bold negative={over} />
      <p className="accounts-hint">Credit days: {data.creditDays}</p>
      {checking && Number(orderAmount) > 0 && (
        <div className={`accounts-note ${over ? "warn" : "ok"}`}>
          {over
            ? `Over the credit limit by ${formatINR(-after)}. The order will be saved on credit hold and needs a manager's approval.`
            : "Within the credit limit. The order will be approved on save."}
        </div>
      )}
    </div>
  );
}
